import { render } from "./SpecialtiesModal.vue?vue&type=template&id=5d077d30"
import script from "./SpecialtiesModal.vue?vue&type=script&lang=js"
export * from "./SpecialtiesModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__